module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/id/2-2f4d9cc0074a51a7f7e09c150a3972c6.jpg";